var render = function render(){var _vm=this,_c=_vm._self._c;return _c('y-layout-body-menu',{attrs:{"menu":[
  {title:'基础配置',path:'/card/plugin/agent/rule'},
  {title:'代理管理',path:'/card/plugin/agent/manage'},
]}},[_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }